<template>
	<div>
		<LoadingSpinner v-if="loading" style="margin-bottom: 10px;" data-cy="loading" />
<!-- TODO: flag for "hasDayMenu" - or can we automatically detect if the dayMenu slot is given/empty? -->
<!--
v-if="calendar.length"
-->
		<DataCalendar ref="dataCalendar" v-if="dates.count > 0"
			:dates="dates"
			:calendar="calendar"
			:limit="limit"
			:clickOpensMenu="false"
			:showDayMenu="false"
			navMode="MONTH"
			v-model:offset="offset"
			v-model:extended="extended"
		>
			<template #dayMenu="{ day }">
				<div class="item" v-if="!dayExpanded[day.date] && day.slots.length > 5" @click="dayExpanded[day.date] = true">
					<v-icon>mdi-unfold-more-horizontal</v-icon> {{ $t('text.expand') }}
				</div>
				<div class="item" v-if="dayExpanded[day.date] && day.slots.length > 5" @click="dayExpanded[day.date] = false">
					<v-icon>mdi-unfold-less-horizontal</v-icon> {{ $t('text.collapse') }}
				</div>
			</template>
			<template #day="{ day }">
				{{ day.availabilityInfo }}
				<div style="display: flex; flex-direction: column; gap: 4px;">
<!-- TODO: expose the 'selectedDay' as prop? -->
					<ContingentSlot v-for="slot in day.slots" :key="'s' + slot.time + update"
						:modelValue="slot"
						:day="day"
						:dates="dates"
						:dayMenu="false"
						:dayExpanded="dayExpanded"
						:dayVisited="dayVisited"
						@click="selectSlot(day, slot)"
						:class="{
							collapsed: !dayExpanded[day.date] && day.slots.length > 5,
							visited: dayVisited[day.date + slot?.time],
						}"
					>
						<template #menu>
							<v-list>
								<v-list-item @click="showOrders(day, slot)"><v-icon>mdi-eye</v-icon> {{ $t('text.showOrders') }}</v-list-item>
								<!-- TODO: dont allow edit on past slots -->
								<IfFeatureFlag flag="FEATURE_CONTINGENT_EDIT">
									<v-list-item @click="editContingent(day, slot)"><v-icon>mdi-pencil</v-icon> {{ $t('text.editContingent') }}</v-list-item>
									<!--
									<v-list-item><v-icon>mdi-delete</v-icon> Delete Contingent</v-list-item>
									-->
								</IfFeatureFlag>
							</v-list>
						</template>
					</ContingentSlot>
				</div>
			</template>
		</DataCalendar>
<!-- TODO: timeslots navigation in a sidebar? -->
		<DialogV2 ref="ordersDialog" width="80%" height="450"
			:title="$t('text.orders') + ' ' + selectedDay?.date + ' ' + selectedSlot?.time"
		>
			<template #sidebar>
				<div style="padding: 32px; display: flex; flex-direction: column; gap: 16px;">
					{{ $t('text.selectedItem') }}
					<ContingentSlotStandalone :modelValue="selectedSlot" :day="selectedDay" :dates="dates" />
					
					<v-divider style="margin: 16px 0;" />
					
					<IfFeatureFlag flag="FEATURE_BULK_ORDER_CANCELLATION">
						<BulkActionsPanel
							v-if="isMysEvent && featureEnabled('bulk-order-cancellation')"
							:selectedDay="selectedDay"
							:selectedSlot="selectedSlot"
							:jobs="jobsForSelectedSlot"
							@cancel-orders="openCancellationDialog"
							@view-job-details="handleViewJobDetails"
						/>
					</IfFeatureFlag>
				</div>
			</template>
			<template #content>
				<ContingentOrders v-if="selectedDay" ref="contingentOrders"
					:order-items="orderItemsSlotSpecific"
				/>
				<!-- ??
					:time="selectedTime?.time"
				-->
			</template>
		</DialogV2>
		<ContingentSlotDialog ref="editContingentDialog"
			:client="client"
			:product="product"
			:selectedDay="selectedDay"
			:selectedSlot="selectedSlot"
			:dates="dates"
			:onConfirm="handleContingentUpdate"
		/>
		<OrderCancellationDialog ref="cancellationDialog"
			:product="product"
			:selectedDay="selectedDay"
			:selectedSlot="selectedSlot"
			:orderItems="orderItemsSlotSpecific"
			:getOrderItems="getOrderItems"
			:currentJob="latestJob"
			@job-started="handleJobStarted"
			@dialog-closed="handleCancellationDialogClosed"
			@request-job-refresh="handleRequestJobRefresh"
		/>
		<JobStatusDialog ref="jobStatusDialog"
			:product="product"
			:selectedDay="selectedDay"
			:selectedSlot="selectedSlot"
			:orderItems="orderItemsSlotSpecific"
			:job="latestJob"
			@monitor-job="handleMonitorJob"
			@restart-job="handleRestartJob"
		/>
		
		<!-- Job Exists Warning Dialog -->
		<Dialog ref="jobExistsDialog"
			:confirmLabel="jobExistsConfirmLabel"
			:cancelLabel="jobExistsCancelLabel"
			:confirm-handler="onJobExistsConfirmed"
			:cancel-handler="onJobExistsCancelled"
			:showClose="false"
			:title="jobExistsTitle"
			height="400px"
			width="600px"
		>
			<template #content>
				<v-row justify="center" align="center" style="padding: 20px">
					<v-col class="warning-icon-col">
						<v-icon size="60" :color="jobExistsIconColor">{{ jobExistsIcon }}</v-icon>
					</v-col>
					<v-col class="text-col">
						<div class="dialog-text">{{ jobExistsMessage }}</div>
					</v-col>
				</v-row>
			</template>
		</Dialog>
	</div>
</template>

<script lang="ts">
import moment from 'moment'
import Common from '../../../mixins/Common.vue'
import DataCalendar from '../../common/DataCalendar.vue'
import LoadingSpinner from '../../common/LoadingSpinner.vue'
import ContingentOrders from './ContingentOrders.vue'
import Dialog from '../../common/Dialog.vue'
import ContingentSlot from './ContingentSlot.vue'
import ContingentSlotFree from './ContingentSlotFree.vue'
import ContingentSlotDialog from './ContingentSlotDialog.vue'
import ContingentSlotStandalone from './ContingentSlotStandalone.vue'
import DialogV2 from '../../common/DialogV2.vue'
import DataDialog from '../../common/DataDialog.vue'
import IfFeatureFlag from '../../ifFeatureFlag/IfFeatureFlag.vue'
import OrderCancellationDialog from './OrderCancellationDialog.vue'
import JobStatusDialog from './JobStatusDialog.vue'
import BulkActionsPanel from './BulkActionsPanel.vue'
import BackgroundJobExecutive from '../../../../../api2/src/modules/jobs/BackgroundJobExecutive'
import Toast from '../../../mixins/Toast.vue'

// TODO: extract the dialog component to a separate file (loading, ..)

// TODO: respect feature flag

// TODO: loading indicator
// TODO: i generalized to DataCalendar -> also migrate BHCalendar to DataCalendar
// TODO: are removed availabilities shown in this result?
// TODO: why do from and until dates have different time formats?
// TODO: shouldnt the from and until only be 1 minute apart? they are 2h1m apart.. is this a TZ issue?
/*
res = {
	availabilities: [{
		"from": "2023-06-01T09:00:00.000Z",
		"until": "2023-06-01T07:01:00Z",
		"used": 0,
		"free": 5,
		"total": 5,
		"overbookFree": 0,
		"overbookTotal": 0,
		"overbook2Total": 0
	}],
}
*/
export default {
	name: 'ContingentCalendarNew',
	mixins: [ Common, Toast ],
	components: { DataCalendar, LoadingSpinner, ContingentOrders, Dialog, ContingentSlot, ContingentSlotFree, ContingentSlotDialog, ContingentSlotStandalone, DialogV2, DataDialog, IfFeatureFlag, OrderCancellationDialog, JobStatusDialog, BulkActionsPanel },
	props: {
		availabilities: Array,
		product: Object,
	},
	data: () => ({
		limit: 7 * 6,
		offset: 0,
		selectedDay: null,
		selectedSlot: null,
		dayMenu: false,
		timeMenu: false,
		space: null,
		availabilityDays: null,
		dayExpanded: {},
		dayVisited: {},
		extended: false,
		extendedLimit: 7 * 52,
		// TODO: this is a bad hack for an update problem:
		//       by setting update we reset all keys on the slots to force their repaint..
		update: 0,
		
		// Job exists dialog data
		jobExistsMode: 'view', // 'view', 'restart'
		jobExistsTitle: '',
		jobExistsMessage: '',
		jobExistsConfirmLabel: '',
		jobExistsCancelLabel: '',
		jobExistsIcon: '',
		jobExistsIconColor: '',

		// Jobs for selected slot - SINGLE SOURCE OF TRUTH for job data
		jobsForSelectedSlot: [] as any[],

		// Order items for selected date and time
		orderItemsSlotSpecific: [],

		// Central job polling
		jobPollInterval: null,
	}),
	computed: {
		// Compute existingJob from jobsForSelectedSlot - the latest job is the "existing" one
		latestJob() {
			if (!this.jobsForSelectedSlot || this.jobsForSelectedSlot.length === 0) {
				return null
			}
			// Return the job with the highest id (number) property
			return this.jobsForSelectedSlot.reduce((highest, current) => {
				return (current.id > highest.id) ? current : highest
			})
		},
		client() {
			return this.$store.state.selectedClient
		},
		dates() {
			const todayDate = moment().startOf('day')
			const today = todayDate.format('YYYY-MM-DD')
			// find min and max date from timespans
			let minDate: string = today
			let maxDate: string = today
			this.availabilities.forEach(ts => {
				const from = ts.fields.validFromDate.de.substring(0, 10)
				if (!minDate || from < minDate) minDate = from
				const to = ts.fields.validToDate.de.substring(0, 10)
				if (!maxDate || to > maxDate) maxDate = to
			})

			let startDate = moment(minDate).startOf('day')
			let fromDate = startDate.clone()
			const toDate = moment(maxDate).endOf('day')
			const fromMonday = fromDate.subtract(1, 'month').startOf('month').startOf('isoWeek')
			const toSunday = toDate.endOf('month').endOf('isoWeek')
			const count = toSunday.diff(fromMonday, 'days') + 1
			const offsetToday = Math.floor(todayDate.diff(startDate, 'days') / this.limit) * this.limit
			return { today, offsetToday, minDate, maxDate, fromDate, toDate, fromMonday, toSunday, count }
		},
		calendar() {
			if (!this.availabilityDays) return []

			// TODO: into separate computed prop since this doesnt change
			const avLookup = {}
			this.availabilityDays.forEach(d => {
				// TODO: TZ?
				const from = moment(d.from)
				const date = d.from.substr(0, 10) //from.format('YYYY-MM-DD')
				if (!avLookup[date]) avLookup[date] = {}
// TODO: slots are offset 2h - probably we may not use moment, but have to cut the time out of the string..
				const time = d.from.substr(11, 5) //from.format('HH:mm')

// TODO: the old comp calculates like this, but how can this be correct?
//       booked: d.total - d.free - d.overbookFree
//          const bookedTotal = (availability.total - availability.free) + (availability.overbookFree * -1)
				avLookup[date][time] = { ...d, time }
			})

			const days = []
			let d = -1
			const from = this.dates.fromMonday.clone()
			const until = this.dates.toSunday.clone()
			for (let day = from; day <= until; day = day.add(1, 'days')) {
				d++
				if (d < this.offset) continue
				if (d >= this.offset + this.limit && !this.extended) continue
				if (d >= this.offset + this.extendedLimit) continue
				const weekday = day.format('dddd').toLowerCase()
				const date = day.format('YYYY-MM-DD')
				const dateObject = day.toDate()
				const year = day.format('YYYY')
				const inRange = date >= this.dates.minDate && date <= this.dates.maxDate
				let open = false

// TODO: add availability info from contingent svc!
				const slots = Object.values(avLookup[date] ?? {})
// TODO: add the exception infos to the day?

// TODO: show day as open if there is an availability for it?

				days.push({ date, open, /*times,*/ inRange, slots, /*exceptionInfo,*/ dateObject, weekday, year })
			}
			return days
		},
		isMysEvent() {
			return this.product?.fields?.clientAssignments?.de?.some(ca => ca.fields?.sku?.de?.startsWith('EVENT.MYSERVICES'))
		}
	},
	methods: {
		async load() {
			if (this.loading) return
			this.loading = true
			try {
				const res = await this.$httpGet(`/contingents/${ this.client.fields.clientId.de }/${ this.product.sys.id }`)
				this.space = res.space
				this.availabilityDays = res.availabilities
			}
			catch (error) {
				console.log(error)
				// TODO
				//this.showError(error)
			}
			this.loading = false
		},
		async selectSlot(day, slot) {
			this.dayVisited[day.date + slot.time] = true
			this.selectedDay = day
			this.selectedSlot = slot
			
			// Fetch jobs for this slot
			await this.loadJobsForSlot()

			// Fetch order items for this slot
			await this.getOrderItems()
		},
		showOrders(day, slot) {
			this.selectSlot(day, slot)
			this.$refs.ordersDialog.open()
			// TODO: hide daymenu of data calendar somehow..
		},
		editContingent(day, slot) {
			this.selectSlot(day, slot)
			this.$refs.editContingentDialog.open()
		},
		handleContingentUpdate(newValue) {
			// Update the internal counter for reactivity
			this.update++
			
			// Emit event to parent component (Availability.vue)
			this.$emit('contingent-updated', {
				newValue,
				day: this.selectedDay,
				slot: this.selectedSlot,
				timestamp: new Date().toISOString()
			})
		},
		navigateToDate(dateString) {
			// Use DataCalendar's jump method to navigate to specific date
			if (this.$refs.dataCalendar && this.$refs.dataCalendar.jump) {
				this.$refs.dataCalendar.jump(dateString)
			}
		},
		async openCancellationDialog() {
			if (this.selectedDay && this.selectedSlot) {
				// Check if a job already exists for this date/timeslot
				const existingJob = await this.checkExistingJob()
				if (existingJob) {
					// If job exists and is running, open for monitoring and start polling
					if (existingJob.status === 'NEW' || existingJob.status === 'RUNNING') {
						this.$refs.cancellationDialog.openForMonitoring()
						this.startJobPolling()
					} else {
						// If job is completed/failed, provide options based on job status
						// existingJob is now computed from jobsForSelectedSlot, no need to set it

						if (existingJob.statusData?.summary?.failedCancellations > 0) {
							// Job has failed items - offer restart option
							this.showJobExistsDialog(
								'restart',
								this.$t('text.jobWithFailedItemsTitle'),
								this.$t('text.jobWithFailedItemsMessage', { 
									status: this.getJobStatusLabel(existingJob.status),
									failedCount: existingJob.statusData.summary.failedCancellations 
								}),
								this.$t('text.restartJobFailedItemsOnly'),
								this.$t('text.viewJobDetails'),
								'mdi-restart',
								'#ff9800'
							)
						} else {
							// Job is completed successfully - just show details
							this.showJobExistsDialog(
								'view',
								this.$t('text.jobAlreadyCompletedTitle'),
								this.$t('text.jobAlreadyCompletedMessage', { 
									status: this.getJobStatusLabel(existingJob.status) 
								}),
								this.$t('text.viewJobDetails'),
								this.$t('text.close'),
								'mdi-check-circle',
								'#4caf50'
							)
						}
					}
				} else {
					// No existing job, open new cancellation dialog
					this.$refs.cancellationDialog.open()
				}
			}
		},
		async cancelContingentForSlot(day, slot) {
			try {
				const clientId = this.$store.state.selectedClient.fields.clientId?.de
				const productId = this.product.sys.id
				
				// Format date and time for the API - match the curl example exactly
				const date = day.date // Should be in YYYY-MM-DD format
				
				// Handle time format - ensure it's in HH:MM format
				let time = slot.time || '00:00'
				
				// If time is not in HH:MM format, try to parse and format it
				if (time && !time.match(/^\d{2}:\d{2}$/)) {
					// Try to extract time from slot data or use default
					console.warn('Unexpected time format:', time, 'using 00:00 instead')
					time = '00:00'
				}
				
				// Find the current total from the slot data
				const currentTotal = slot.total || 0
				
				// Prepare the API payload - match the curl request format exactly
				const startDateTime = `${date}T${time}:00.000`
				
				// End time should be exactly 1 minute later - parse time and add 1 minute
				const [hours, minutes] = time.split(':').map(Number)
				const endMinutes = minutes + 1
				const endHours = endMinutes >= 60 ? hours + 1 : hours
				const finalEndMinutes = endMinutes >= 60 ? endMinutes - 60 : endMinutes
				const endTime = `${String(endHours).padStart(2, '0')}:${String(finalEndMinutes).padStart(2, '0')}`
				const endDateTime = `${date}T${endTime}:00.000`
				
				const payload = {
					startDate: startDateTime,
					endDate: endDateTime,
					oldTotal: currentTotal,
					newTotal: 0
				}
				
				// Make the API call to cancel the contingent - using POST as corrected
				const response = await this.$httpPost(
					`/contingents/${clientId}/${productId}/${date}/${time}`,
					payload
				)
				
				console.log('Contingent cancelled successfully:', response)
				
				// Update the local slot data to reflect the change with proper Vue 3 reactivity
				if (slot) {
					// Update the slot object
					slot.total = 0
					slot.free = 0
				}
				
				// Also update the availabilityDays data structure to ensure calendar reactivity
				if (this.availabilityDays) {
					// Find and update the corresponding availability record
					// availabilityDays contains records with 'from' field like "2025-10-05T00:00:00.000Z"
					const targetDateTime = `${date}T${time}:00.000Z`
					
					// Find the availability record that matches our date/time
					const availabilityRecord = this.availabilityDays.find(d => {
						const recordDate = d.from.substr(0, 10) // Extract YYYY-MM-DD
						const recordTime = d.from.substr(11, 5) // Extract HH:MM
						return recordDate === date && recordTime === time
					})
					
					if (availabilityRecord) {
						// Update the record directly
						availabilityRecord.total = 0
						availabilityRecord.free = 0
						
						console.log('Updated availabilityDays record:', availabilityRecord)
					} else {
						console.warn('Could not find matching availability record for', date, time)
					}
				}
				
				// Force reactivity update for the selected slot if it matches
				if (this.selectedDay?.date === date && this.selectedSlot?.time === time) {
					// Update selectedSlot to trigger reactivity
					this.selectedSlot = { ...this.selectedSlot, total: 0, free: 0 }
				}
				
				// Emit an event to notify other components of the change
				this.$emit('contingent-updated', { date, time, total: 0, free: 0 })
				
				this.showSuccessToast(this.$t('text.contingentCancelledForSlot', { 
					date: this.formatDate(date), 
					time: time 
				}), true)
				
				return response
				
			} catch (error) {
				console.error('Failed to cancel contingent:', error)
				
				// Log the full error details for debugging
				if (error.response) {
					console.error('Error response:', error.response.data)
					console.error('Error status:', error.response.status)
					console.error('Error headers:', error.response.headers)
				}
				
				// Show more specific error message if available
				const errorMessage = error.response?.data?.message || error.message || this.$t('text.failedToCancelContingent')
				this.showErrorToast(errorMessage)
				throw error
			}
		},

		async handleJobStarted(jobId, model) {
			// Optionally close the orders dialog and show a toast
			console.log('Cancellation job started with ID:', jobId)

			// Immediately update the existing job state to disable the bulk action button
			await this.checkExistingJob()

			// Start centralized polling for this job
			this.startJobPolling()

			// Automatically cancel the contingent for this slot if requested
			if (model?.cancelContingent && this.selectedDay && this.selectedSlot) {
				try {
					await this.cancelContingentForSlot(this.selectedDay, this.selectedSlot)
					console.log('Contingent automatically cancelled for slot during job start')
				} catch (error) {
					console.error('Failed to cancel contingent during job start:', error)
					// Don't throw - job should continue even if contingent cancellation fails
				}
			}

			this.showSuccessToast('jobStarted')
		},
		async handleCancellationDialogClosed() {
			// Stop polling when dialog is closed
			this.stopJobPolling()

			// Refresh order items when dialog is closed to show updated statuses
			if (this.selectedDay && this.selectedSlot) {
				console.log('Refreshing order items after dialog close...')

				// Small delay to ensure dialog is fully closed and DOM is ready
				await new Promise(resolve => setTimeout(resolve, 100))
				// nextTick to ensure the DOM is fully updated
				await this.$nextTick()

				// Refresh the ContingentOrders component to show updated statuses
				if (this.$refs.contingentOrders?.load) {
					await this.$refs.contingentOrders.load()
				}

				// Also reload the calendar data to reflect any changes
				this.$emit('load')
			}
		},
		handleViewJobDetails(job) {
			// Open the job status dialog to view specific job details
			console.log('Viewing job details:', job)
			this.$refs.jobStatusDialog.open(job)
		},
		handleMonitorJob(job) {
			// Open the cancellation dialog and set it to monitor the existing job
			console.log('Monitoring job:', job)
			// Job is already in existingJob prop, just open the dialog
			this.$refs.cancellationDialog.openForMonitoring()
		},
		handleRestartJob(job) {
			// Open the cancellation dialog to restart the job with only failed items
			console.log('Restarting job:', job)
			this.$refs.cancellationDialog.openForRestart(job)
		},
		async loadJobsForSlot() {
			try {
				const executive = new BackgroundJobExecutive(this)
				
				const response = await executive.getCancelOrdersJobs(
					this.product.sys.id,
					this.selectedDay.date,
					this.selectedSlot.time
				)
				
				// Store all jobs for this slot (including restarts) - SINGLE SOURCE OF TRUTH
				this.jobsForSelectedSlot = response || []
				// existingJob is computed from this array automatically

				console.log(`Loaded ${this.jobsForSelectedSlot.length} jobs for slot`)
			} catch (error) {
				console.error('Failed to load jobs for slot:', error)
				this.jobsForSelectedSlot = []
				// existingJob will be automatically null when array is empty
			}
		},
		async checkExistingJob() {
			// Re-fetch jobs to update the list
			await this.loadJobsForSlot()
			return this.latestJob
		},
		getJobStatusLabel(status) {
			switch (status) {
				case 'NEW': return this.$t('text.jobStatusPending')
				case 'RUNNING': return this.$t('text.jobStatusRunning')
				case 'DONE': return this.$t('text.jobStatusCompleted')
				case 'ERROR': return this.$t('text.jobStatusFailed')
				default: return status
			}
		},
		showJobExistsDialog(mode, title, message, confirmLabel, cancelLabel, icon, iconColor) {
			this.jobExistsMode = mode
			this.jobExistsTitle = title
			this.jobExistsMessage = message
			this.jobExistsConfirmLabel = confirmLabel
			this.jobExistsCancelLabel = cancelLabel
			this.jobExistsIcon = icon
			this.jobExistsIconColor = iconColor
			this.$refs.jobExistsDialog.show = true
		},
		onJobExistsConfirmed() {
			if (this.jobExistsMode === 'restart') {
				this.$refs.cancellationDialog.openForRestart(this.latestJob)
			} else {
				// Use openForMonitoring to view job details with the cancellation dialog
				this.$refs.cancellationDialog.openForMonitoring()
			}
			this.$refs.jobExistsDialog.show = false
		},
		onJobExistsCancelled() {
			if (this.jobExistsMode === 'restart') {
				// If user cancels restart, show job details instead using openForMonitoring
				this.$refs.cancellationDialog.openForMonitoring()
			}
			this.$refs.jobExistsDialog.show = false
		},
		async getOrderItems() {
			try {
				let sku = ''
				if (this.product?.fields?.clientAssignments?.de?.length) {
					for (const clientAssignment of this.product.fields.clientAssignments.de) {
						if (clientAssignment?.fields?.sku?.de) {
							sku = clientAssignment.fields.sku.de
							break
						}
					}
				}

				let apiUrl = `/order-items?sku=${sku}`

				if (this.selectedDay?.date) {
					apiUrl += `&eventDate=${this.selectedDay.date}`
				}
				if (this.selectedSlot?.time) {
					apiUrl += `&timeslot=${this.selectedSlot.time}:00`
				}

				const res = await this.$httpGet(apiUrl)
				this.orderItemsSlotSpecific = res.orderItems || []
			} catch (error) {
				console.error('Error loading order items:', error)
				return []
			}
		},

		// Centralized job polling methods
		startJobPolling() {
			// Clear any existing interval
			this.stopJobPolling()

			console.log('Starting centralized job polling')

			// Poll every 2 seconds for job status updates
			this.jobPollInterval = setInterval(async () => {
				await this.pollJobStatus()
			}, 2000)
		},

		stopJobPolling() {
			if (this.jobPollInterval) {
				console.log('Stopping centralized job polling')
				clearInterval(this.jobPollInterval)
				this.jobPollInterval = null
			}
		},

		async pollJobStatus() {
			// Only poll if we have an existing job that's still running
			if (!this.latestJob?.jobId) {
				this.stopJobPolling()
				return
			}

			const isRunning = this.latestJob.status === 'NEW' || this.latestJob.status === 'RUNNING'
			if (!isRunning) {
				this.stopJobPolling()
				return
			}

			try {
				const executive = new BackgroundJobExecutive(this)
				const response = await executive.getJobStatus(this.latestJob.jobId)

				// Update the job in jobsForSelectedSlot array (SINGLE SOURCE OF TRUTH)
				if (response.job) {
					const jobIndex = this.jobsForSelectedSlot.findIndex(j => j.jobId === response.job.jobId)
					if (jobIndex !== -1) {
						// Update the existing job in the array
						this.jobsForSelectedSlot.splice(jobIndex, 1, { ...response.job })
					} else {
						// Job not found in array - this shouldn't happen, but handle it
						console.warn('Job not found in jobsForSelectedSlot array during poll')
					}
				}

				// Refresh order items to get updated status from database
				await this.getOrderItems()

				// Check if job completed (existingJob is now computed, so it's automatically updated)
				const stillRunning = this.latestJob?.status === 'NEW' || this.latestJob?.status === 'RUNNING'
				if (!stillRunning) {
					this.stopJobPolling()
					console.log('Job completed, stopped centralized polling')
				}
			} catch (error) {
				console.error('Failed to poll job status:', error)
				this.stopJobPolling()
			}
		},

		async handleRequestJobRefresh() {
			// Handler for when child components request a job refresh
			console.log('Child requested job refresh')
			await this.checkExistingJob()
		},
	},
	async mounted() {
		await this.load()
	},
	beforeUnmount() {
		// Clean up polling when component is destroyed
		this.stopJobPolling()
	},
}
</script>

<style scoped>
.slot { padding: 1px 4px; margin-bottom: 2px; background: #eee; border-radius: 4px; position: relative; }
.slot.collapsed { display: inline-block; margin-right: 2px; }
.slot.collapsed .time { display: none; }
.slot.collapsed .total { display: none; }
.slot:hover { outline: 2px solid #333; cursor: pointer; }
.slot.visited::after { content: ""; position: absolute; top: 2px; right: 2px; width: 3px; height: 3px; border-radius: 3px; background: violet; }

/* Job exists dialog styles */
.warning-icon-col {
	flex: 1;
	text-align: center;
}

.text-col {
	flex: 2;
	text-align: left;
	padding-left: 20px;
}

.dialog-text {
	color: #666;
	font-size: 16px;
	font-weight: normal;
	line-height: 1.4;
	letter-spacing: -0.3px;
}

</style>